import { motion } from "framer-motion";
import "./About.css";

const team = [
  {
    name: "Dr. Saul Troen",
    role: "Founder & Chairman",
    bio: "Leading ChipServer's vision and strategic direction",
  },
  {
    name: "Vincent J Mattone",
    role: "President & CEO",
    bio: "Driving business growth and operational excellence",
  },
  {
    name: "David Glickman",
    role: "SVP Sales & Marketing",
    bio: "Leading sales strategy and market expansion",
  },
 
  {
    name: "Dr. Monica Sanchez",
    role: "VP, African & Caribbean Affairs",
    bio: "Leading African & Caribbean initiatives, driving inclusive innovation and global partnerships.",
  },
  {
    name: "Christopher Howell",
    role: "Chief Engineer",
    bio: "Overseeing technical innovation and product development",
  },
  {
    name: "Nick Sakatis",
    role: "Director, Security Operations & Development",
    bio: "Managing security infrastructure and development",
  },
  {
    name: "Jesse Briggs",
    role: "Director of Operations, Israel & Middle East",
    bio: "Overseeing regional operations and partnerships across Israel and the Middle East",
  },
  {
    name: "Palak Seth",
    role: "Director, Finance & Business Analytics",
    bio: "Overseeing financial strategy and business analysis",
  },
  {
    name: "Rafinal Haque",
    role: "Director, Product Testing",
    bio: "Ensuring product quality and performance",
  },
 
];

export default function About() {
  return (
    <div className="about-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1>About ChipServer</h1>
        <p className="subtitle">
          Ever found yourself needing to work, store, or show files to peers,
          but there's no internet connection? ChipServer is your perfect
          solution! Our portable file-broadcasting and storage device brings
          digital equality to everyone, everywhere.
        </p>
      </motion.div>

      <section>
        <h2>Our Mission</h2>
        <div className="section-text">
          <p>
            Our mission is to bridge the digital divide and provide digital
            equality for all, especially for people without stable Internet or
            computer access in the world. We believe that access to digital
            resources shouldn't be limited by connectivity constraints.
          </p>
          <p>
            With ChipServer, your files are always at your fingertips—anytime,
            anywhere. Experience the convenience of having your very own
            personal cloud server, in your pocket! This revolutionary approach
            to file sharing and storage empowers users to access and share their
            files effortlessly, without the need for Wi-Fi or mobile data.
          </p>
        </div>
      </section>

      <section>
        <h2>Our Story</h2>
        <div className="section-text">
          <p>
            The ChipServer journey began in 2014 when Professor Saul Troen
            encountered a common challenge while teaching – the university's
            internet wasn't working. This sparked the idea for ChipServer.
          </p>
          <p>
            After years of dedicated R&D, the first working prototypes were
            created in 2018, marking a significant milestone in our journey. In
            2019, we achieved another major breakthrough when we were granted a
            utility patent for wireless transmission of USB storage devices
            (Patent #: US-1028946-B2).
          </p>
          <p>
            Today, ChipServer continues to evolve and innovate. In 2024, we
            launched our company and began bringing our solution to market.
            Looking ahead to 2025 and beyond, we’re excited about further
            enhancing our technology and expanding our reach to help more people
            bridge the digital divide.
          </p>
        </div>
      </section>

      <section>
        <h2>Meet Our Team</h2>
        <div className="grid-team">
          {team.map((member) => (
            <div key={member.name} className="team-card">
              <h3 translate="no">{member.name}</h3>
              <div className="role">{member.role}</div>
              <p>{member.bio}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
